import type { FinalReviewSection, HandBackTarget } from '../../../../services/finalReview';

export const MAX_HAND_BACK_NOTES = 30;
export const MAX_HAND_BACK_NOTE_LENGTH = 2000;

export const HAND_BACK_TARGET_LABELS: Record<HandBackTarget, string> = {
    design: 'Design',
    dx: 'Dx',
    both: 'Design & Dx'
};

// Anything but a design note is a Dx note, including older hand-backs' Dx section ids.
export function sectionOf(section: string): FinalReviewSection {
    return section === 'design' ? 'design' : 'dx';
}

export function noteSectionLabel(section: string): string {
    return HAND_BACK_TARGET_LABELS[sectionOf(section)];
}

export function notesInSection<T extends { section: string }>(
    notes: readonly T[],
    section: FinalReviewSection
): T[] {
    return notes.filter((n) => sectionOf(n.section) === section);
}

// Same rule as the backend's targetOf: a design note sends the case back to design.
export function handBackTarget(notes: readonly { section?: string }[]): HandBackTarget {
    const onDesign = notes.some((n) => n.section === 'design');
    const onDx = notes.some((n) => n.section !== 'design');
    if (onDesign && onDx) return 'both';
    return onDesign ? 'design' : 'dx';
}

export function handBackBlocker(
    notes: readonly { section?: string; text: string }[]
): string | null {
    if (notes.length === 0) return 'Add a note to hand back';
    if (notes.length > MAX_HAND_BACK_NOTES) return `At most ${MAX_HAND_BACK_NOTES} notes`;
    if (notes.some((n) => n.text.trim().length === 0)) return 'Fill in or remove empty notes';
    if (notes.some((n) => n.text.trim().length > MAX_HAND_BACK_NOTE_LENGTH)) {
        return `Notes are limited to ${MAX_HAND_BACK_NOTE_LENGTH.toLocaleString()} characters`;
    }
    return null;
}
